import ky from 'ky';
class HTTPError extends Error { }
const client = ky.extend({
  prefixUrl: process.env.REACT_APP_FRONTEND_API_URL,
  // prefixUrl : 'http://127.0.0.1:8000/api/',

  hooks: {
    beforeRequest: [
      () => {
        // Do something before every request
        // This is a good place to authorize request if needed
      }
    ],
    afterResponse: [
      // Or retry with a fresh token on a 403 error
      async (response) => {
        if (response.status === 401) {
          const body = await response.json()
          throw new HTTPError(body.message);
        }
      }
    ]
  }
});

export default client;